module.exports = __webpack_public_path__ + "src/img/clockbeats/cb_world_map.25ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clockbeats/cb_world_map.jpg
// module id = 98
// module chunks = 0